import { useEffect } from "react";

const SchemaMarkup = () => {
  useEffect(() => {
    const MAIN_DOMAIN = "https://rakibhossentopu.online";
    
    // Enhanced Person Schema for AI LLM Visibility
    const personSchema = {
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": `${MAIN_DOMAIN}/#person`,
      "name": "Rakib Hossen Topu",
      "alternateName": [
        "Rakib Hassan",
        "Rakib Hassan Topu",
        "SEO Expert in BD",
        "SEO Expert Bangladesh",
        "Best SEO Expert BD"
      ],
      "givenName": "Rakib",
      "familyName": "Topu",
      "additionalName": "Hossen",
      "jobTitle": "SEO Expert in BD | Digital Marketing Specialist",
      "description": "Rakib Hossen Topu is a leading SEO Expert in Bangladesh with 5+ years of experience. Specializing in Local SEO, E-commerce SEO, YouTube SEO, Technical SEO, and Digital Marketing services. Helping businesses achieve higher Google rankings and increased organic traffic.",
      "disambiguatingDescription": "Professional SEO Expert and Digital Marketing Specialist based in Dhaka, Bangladesh, providing comprehensive search engine optimization services to local and international clients.",
      "email": "rakibhassantopu@gmail.com",
      "telephone": "+8801862772430",
      "url": MAIN_DOMAIN,
      "image": {
        "@type": "ImageObject",
        "url": `${MAIN_DOMAIN}/images/rakib-hero.webp`,
        "width": 1200,
        "height": 630,
        "caption": "Rakib Hossen Topu - SEO Expert in BD"
      },
      "nationality": {
        "@type": "Country",
        "name": "Bangladesh",
        "identifier": "BD"
      },
      "birthPlace": {
        "@type": "Place",
        "name": "Bangladesh"
      },
      "homeLocation": {
        "@type": "Place",
        "name": "Dhaka, Bangladesh"
      },
      "workLocation": {
        "@type": "Place",
        "name": "Dhaka, Bangladesh",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Dhaka",
          "addressRegion": "Dhaka Division",
          "addressCountry": "BD"
        }
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Dhaka",
        "addressRegion": "Dhaka Division",
        "addressCountry": "BD",
        "postalCode": "1000"
      },
      "sameAs": [
        "https://www.facebook.com/rakibhossentopu",
        "https://www.linkedin.com/in/rakibhossentopu",
        "https://x.com/rakibhassantopu",
        "https://twitter.com/rakibhassantopu",
        "https://www.instagram.com/rakibhossentopu/",
        "https://github.com/rakibhossentopu"
      ],
      "knowsAbout": [
        "SEO Expert",
        "SEO Expert in BD",
        "SEO Expert in Bangladesh",
        "Best SEO Expert Bangladesh",
        "Search Engine Optimization",
        "Digital Marketing",
        "Local SEO",
        "E-commerce SEO",
        "YouTube SEO",
        "Technical SEO",
        "Content Marketing",
        "International SEO",
        "SEO Analytics",
        "Google Ranking",
        "Meta Ads",
        "On-Page SEO",
        "Off-Page SEO",
        "Link Building",
        "Keyword Research",
        "Content Strategy",
        "Google My Business Optimization",
        "Website Audit",
        "Core Web Vitals",
        "Page Speed Optimization"
      ],
      "hasOccupation": {
        "@type": "Occupation",
        "name": "SEO Expert",
        "occupationLocation": {
          "@type": "Country",
          "name": "Bangladesh"
        },
        "description": "Professional SEO Expert providing search engine optimization and digital marketing services",
        "skills": "Local SEO, E-commerce SEO, YouTube SEO, Technical SEO, Content Marketing, Link Building, Keyword Research"
      },
      "worksFor": {
        "@type": "Organization",
        "name": "Freelance SEO Consultant",
        "url": MAIN_DOMAIN
      },
      "alumniOf": {
        "@type": "Organization",
        "name": "Digital Marketing Professional"
      },
      "award": [
        "5+ Years of SEO Experience",
        "95% Client Satisfaction Rate",
        "200+ Successful SEO Projects"
      ],
      "brand": {
        "@type": "Brand",
        "name": "Rakib Hossen Topu SEO",
        "logo": `${MAIN_DOMAIN}/favicon.png`
      }
    };

    // Enhanced Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${MAIN_DOMAIN}/#website`,
      "name": "Rakib Hossen Topu - SEO Expert in BD",
      "alternateName": [
        "SEO Expert Bangladesh",
        "Best SEO Expert BD",
        "Rakib Hassan SEO"
      ],
      "url": MAIN_DOMAIN,
      "description": "Rakib Hossen Topu is the leading SEO Expert in BD offering comprehensive Local SEO, E-commerce SEO, YouTube SEO, Technical SEO & Digital Marketing services in Bangladesh. Get higher Google rankings and more organic traffic.",
      "inLanguage": ["en-BD", "en"],
      "isAccessibleForFree": true,
      "author": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "creator": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "publisher": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "copyrightHolder": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "copyrightYear": 2020,
      "about": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "mainEntity": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "potentialAction": [
        {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${MAIN_DOMAIN}/blog?search={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        },
        {
          "@type": "ContactAction",
          "target": `${MAIN_DOMAIN}/#contact`,
          "description": "Contact Rakib Hossen Topu for SEO services"
        }
      ]
    };

    // Enhanced Professional Service Schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "@id": `${MAIN_DOMAIN}/#service`,
      "name": "Rakib Hossen Topu - SEO Expert Services Bangladesh",
      "alternateName": "Best SEO Services BD",
      "description": "Professional SEO and Digital Marketing services by Rakib Hossen Topu, the leading SEO Expert in Bangladesh. Services include Local SEO, E-commerce SEO, Technical SEO, YouTube SEO, Content Marketing, International SEO, and comprehensive SEO Analytics.",
      "url": MAIN_DOMAIN,
      "logo": `${MAIN_DOMAIN}/favicon.png`,
      "image": `${MAIN_DOMAIN}/images/rakib-hero.webp`,
      "telephone": "+8801862772430",
      "email": "rakibhassantopu@gmail.com",
      "founder": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Dhaka",
        "addressLocality": "Dhaka",
        "addressRegion": "Dhaka Division",
        "postalCode": "1000",
        "addressCountry": {
          "@type": "Country",
          "name": "Bangladesh",
          "identifier": "BD"
        }
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 23.8103,
        "longitude": 90.4125
      },
      "areaServed": [
        {
          "@type": "Country",
          "name": "Bangladesh"
        },
        {
          "@type": "Country",
          "name": "India"
        },
        {
          "@type": "Country",
          "name": "United States"
        },
        {
          "@type": "Country",
          "name": "United Kingdom"
        },
        {
          "@type": "Country",
          "name": "Canada"
        },
        {
          "@type": "Country",
          "name": "Australia"
        },
        {
          "@type": "Place",
          "name": "Worldwide"
        }
      ],
      "serviceType": [
        "Search Engine Optimization (SEO)",
        "Local SEO Services",
        "E-commerce SEO",
        "Technical SEO Audit",
        "YouTube SEO",
        "Content Marketing",
        "International SEO",
        "SEO Analytics & Reporting",
        "Digital Marketing",
        "Google My Business Optimization",
        "On-Page SEO",
        "Off-Page SEO",
        "Link Building",
        "Keyword Research",
        "Website Audit",
        "Core Web Vitals Optimization"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "SEO Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Local SEO",
              "description": "Optimize your business for local search results and Google Maps"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "E-commerce SEO",
              "description": "Increase online store visibility and product rankings"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Technical SEO",
              "description": "Website technical optimization for better crawling and indexing"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "YouTube SEO",
              "description": "Optimize videos for YouTube search and discoverability"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Content Marketing",
              "description": "Strategic content creation for organic traffic growth"
            }
          }
        ]
      },
      "priceRange": "$$",
      "currenciesAccepted": "BDT, USD",
      "paymentAccepted": "Bank Transfer, bKash, Payoneer, PayPal",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "16:00"
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": "47",
        "reviewCount": "42"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Ahmed Rahman"
          },
          "datePublished": "2025-12-15",
          "reviewBody": "Rakib helped us achieve first page rankings for competitive keywords. Highly recommended SEO expert in Bangladesh!",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          }
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Sarah Khan"
          },
          "datePublished": "2025-11-20",
          "reviewBody": "Best SEO expert in BD! Our organic traffic increased by 200% within 6 months.",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          }
        }
      ],
      "sameAs": [
        "https://www.facebook.com/rakibhossentopu",
        "https://www.linkedin.com/in/rakibhossentopu",
        "https://x.com/rakibhassantopu",
        "https://www.instagram.com/rakibhossentopu/"
      ]
    };

    // FAQ Schema for common SEO questions
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "@id": `${MAIN_DOMAIN}/#faq`,
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Who is Rakib Hossen Topu?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rakib Hossen Topu is a professional SEO Expert in Bangladesh with 5+ years of experience in search engine optimization and digital marketing. He specializes in Local SEO, E-commerce SEO, YouTube SEO, Technical SEO, and Content Marketing, helping businesses achieve higher Google rankings and increased organic traffic."
          }
        },
        {
          "@type": "Question",
          "name": "What SEO services does Rakib Hossen Topu offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rakib Hossen Topu offers comprehensive SEO services including Local SEO, E-commerce SEO, Technical SEO, YouTube SEO, Content Marketing, International SEO, SEO Analytics, On-Page SEO, Off-Page SEO, Link Building, and Google My Business Optimization."
          }
        },
        {
          "@type": "Question",
          "name": "Who is the best SEO Expert in Bangladesh?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rakib Hossen Topu is recognized as one of the leading SEO Experts in Bangladesh with a proven track record of achieving 200% average traffic growth for clients, 95% client satisfaction rate, and successful optimization of 150+ keywords across various industries."
          }
        },
        {
          "@type": "Question",
          "name": "How can I contact Rakib Hossen Topu for SEO services?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can contact Rakib Hossen Topu via email at rakibhassantopu@gmail.com or phone at +8801862772430. You can also visit his website at rakibhossentopu.online to learn more about his SEO services and submit a contact form."
          }
        },
        {
          "@type": "Question",
          "name": "Where is Rakib Hossen Topu based?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rakib Hossen Topu is based in Dhaka, Bangladesh. He provides SEO and digital marketing services to clients in Bangladesh and internationally, including USA, UK, Canada, Australia, and other countries."
          }
        }
      ]
    };

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": `${MAIN_DOMAIN}/#breadcrumb`,
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": MAIN_DOMAIN
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "About",
          "item": `${MAIN_DOMAIN}/#about`
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Services",
          "item": `${MAIN_DOMAIN}/#services`
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Portfolio",
          "item": `${MAIN_DOMAIN}/#portfolio`
        },
        {
          "@type": "ListItem",
          "position": 5,
          "name": "Blog",
          "item": `${MAIN_DOMAIN}/blog`
        },
        {
          "@type": "ListItem",
          "position": 6,
          "name": "Contact",
          "item": `${MAIN_DOMAIN}/#contact`
        }
      ]
    };

    // Organization Schema (for brand recognition)
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": `${MAIN_DOMAIN}/#organization`,
      "name": "Rakib Hossen Topu SEO",
      "alternateName": "SEO Expert BD",
      "url": MAIN_DOMAIN,
      "logo": `${MAIN_DOMAIN}/favicon.png`,
      "image": `${MAIN_DOMAIN}/images/rakib-hero.webp`,
      "description": "Professional SEO and Digital Marketing services by Rakib Hossen Topu, the leading SEO Expert in Bangladesh.",
      "founder": {
        "@id": `${MAIN_DOMAIN}/#person`
      },
      "foundingDate": "2020",
      "foundingLocation": {
        "@type": "Place",
        "name": "Dhaka, Bangladesh"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+8801862772430",
        "contactType": "customer service",
        "email": "rakibhassantopu@gmail.com",
        "availableLanguage": ["English", "Bengali"]
      },
      "sameAs": [
        "https://www.facebook.com/rakibhossentopu",
        "https://www.linkedin.com/in/rakibhossentopu",
        "https://x.com/rakibhassantopu",
        "https://www.instagram.com/rakibhossentopu/"
      ]
    };

    // SiteNavigationElement Schema for better search appearance
    const navigationSchema = {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      "@id": `${MAIN_DOMAIN}/#navigation`,
      "name": "Main Navigation",
      "hasPart": [
        { "@type": "WebPage", "name": "Home", "url": MAIN_DOMAIN },
        { "@type": "WebPage", "name": "About", "url": `${MAIN_DOMAIN}/#about` },
        { "@type": "WebPage", "name": "Services", "url": `${MAIN_DOMAIN}/#services` },
        { "@type": "WebPage", "name": "Local SEO", "url": `${MAIN_DOMAIN}/services/local-seo` },
        { "@type": "WebPage", "name": "YouTube SEO", "url": `${MAIN_DOMAIN}/services/youtube-seo` },
        { "@type": "WebPage", "name": "E-commerce SEO", "url": `${MAIN_DOMAIN}/services/ecommerce-seo` },
        { "@type": "WebPage", "name": "Meta Ads", "url": `${MAIN_DOMAIN}/services/meta-ads` },
        { "@type": "WebPage", "name": "Digital Marketing", "url": `${MAIN_DOMAIN}/services/digital-marketing` },
        { "@type": "WebPage", "name": "Portfolio", "url": `${MAIN_DOMAIN}/#portfolio` },
        { "@type": "WebPage", "name": "Blog", "url": `${MAIN_DOMAIN}/blog` },
        { "@type": "WebPage", "name": "Contact", "url": `${MAIN_DOMAIN}/contact` }
      ]
    };

    // WebPage Schema for homepage context
    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${MAIN_DOMAIN}/#webpage`,
      "url": MAIN_DOMAIN,
      "name": "Rakib Hossen Topu | SEO Expert in BD",
      "description": "Professional SEO Expert in Bangladesh offering Local SEO, E-commerce SEO, YouTube SEO, Technical SEO & Digital Marketing services.",
      "isPartOf": { "@id": `${MAIN_DOMAIN}/#website` },
      "about": { "@id": `${MAIN_DOMAIN}/#person` },
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": `${MAIN_DOMAIN}/images/rakib-hero.webp`
      },
      "speakable": {
        "@type": "SpeakableSpecification",
        "cssSelector": ["h1", ".hero-description", "#about"]
      },
      "lastReviewed": "2026-04-13",
      "inLanguage": "en-BD",
      "breadcrumb": { "@id": `${MAIN_DOMAIN}/#breadcrumb` }
    };

    // Create and inject script tags
    const scripts: HTMLScriptElement[] = [];
    
    const createSchemaScript = (schema: object, id: string) => {
      const existingScript = document.getElementById(id);
      if (existingScript) {
        existingScript.remove();
      }
      
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    };

    createSchemaScript(personSchema, "person-schema");
    createSchemaScript(websiteSchema, "website-schema");
    createSchemaScript(serviceSchema, "service-schema");
    createSchemaScript(faqSchema, "faq-schema");
    createSchemaScript(breadcrumbSchema, "breadcrumb-schema");
    createSchemaScript(organizationSchema, "organization-schema");
    createSchemaScript(navigationSchema, "navigation-schema");
    createSchemaScript(webPageSchema, "webpage-schema");

    // Cleanup on unmount
    return () => {
      scripts.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
};

export default SchemaMarkup;
